export const ACTION_RESET = 'FETCH_EVENTDATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_EVENTDATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_EVENTDATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_EVENTDATALIST_ERROR';
